// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-picture > div {
  margin: auto;
}
.select-picture .error-message {
  color: var(--ion-color-danger);
}
.select-picture .success-message {
  margin-top: 40px;
  margin-bottom: 40px;
  color: var(--ion-color-success);
  font-size: 20px;
  font-weight: bold;
}
.select-picture .success-message ion-icon {
  font-size: 24px;
}
.select-picture .action-bar {
  display: flex;
  justify-content: flex-end;
}
.select-picture .step-description {
  font-size: 18px;
  color: var(--ion-color-medium);
}
.select-picture .select-step-block {
  margin-top: 50px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.select-picture .select-step-block .reuse-image ion-button {
  width: 500px;
  height: 300px;
  margin: 0;
}
.select-picture .select-step-block .reuse-image-separator {
  font-weight: bolder;
  font-size: 18px;
}
.select-picture .select-step-block .selection-container {
  width: 500px;
  text-align: center;
}
.select-picture .select-step-block .selection-container .dropzone {
  width: 500px;
  height: 300px;
  padding: 50px 20px 20px;
  text-align: center;
  border: dashed 1px var(--ion-color-medium);
  position: relative;
  cursor: pointer;
}
.select-picture .select-step-block .selection-container .dropzone i {
  font-size: 50px;
}
.select-picture .select-step-block .selection-container .dropzone input {
  opacity: 0;
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  cursor: pointer;
}
.select-picture .select-step-block .selection-container .dropzone.fileover {
  background-color: var(--ion-color-light-shade);
}
.select-picture .crop-container {
  align-items: center;
  display: flex;
  justify-content: space-around;
}
.select-picture .crop-container .crop-container-actions {
  display: flex;
  flex-direction: column;
}
.select-picture .crop-container image-cropper {
  --cropper-outline-color: rgba(0, 0, 0, 0.5);
  max-width: 800px;
  max-height: 600px;
  overflow: hidden;
}
.select-picture .flag-container {
  max-width: 1000px;
}
.select-picture .flag-container .flag-image-container {
  max-width: 800px;
  margin: auto;
  border: 1px solid var(--ion-color-light-shade);
}
.select-picture .flag-container .flag-image-container img {
  display: block;
  -webkit-user-select: none;
  -o-user-select: none;
  user-select: none;
}
.select-picture .flag-container .flag-image-container .flag {
  position: absolute;
  z-index: 1;
  bottom: 50%;
  left: 50%;
  font-size: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/module/app/membership/components/select-picture/select-picture-modal.component.scss"],"names":[],"mappings":"AACE;EACE,YAAA;AAAJ;AAGE;EACE,8BAAA;AADJ;AAIE;EACE,gBAAA;EACA,mBAAA;EACA,+BAAA;EACA,eAAA;EACA,iBAAA;AAFJ;AAII;EACE,eAAA;AAFN;AAME;EACE,aAAA;EACA,yBAAA;AAJJ;AAOE;EACE,eAAA;EACA,8BAAA;AALJ;AAQE;EACE,gBAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;AANJ;AASM;EACE,YAAA;EACA,aAAA;EACA,SAAA;AAPR;AAWI;EACE,mBAAA;EACA,eAAA;AATN;AAYI;EACE,YAAA;EACA,kBAAA;AAVN;AAYM;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,0CAAA;EACA,kBAAA;EACA,eAAA;AAVR;AAYQ;EACE,eAAA;AAVV;AAaQ;EACE,UAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,eAAA;AAXV;AAcQ;EACE,8CAAA;AAZV;AAmBE;EACE,mBAAA;EACA,aAAA;EACA,6BAAA;AAjBJ;AAmBI;EACE,aAAA;EACA,sBAAA;AAjBN;AAoBI;EACE,2CAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAlBN;AAsBE;EACE,iBAAA;AApBJ;AAsBI;EACE,gBAAA;EACA,YAAA;EACA,8CAAA;AApBN;AAsBM;EACE,cAAA;EACA,yBAAA;EAGA,oBAAA;EACA,iBAAA;AApBR;AAuBM;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;AArBR","sourcesContent":[".select-picture {\n  & > div {\n    margin: auto;\n  }\n\n  .error-message {\n    color: var(--ion-color-danger);\n  }\n\n  .success-message {\n    margin-top: 40px;\n    margin-bottom: 40px;\n    color: var(--ion-color-success);\n    font-size: 20px;\n    font-weight: bold;\n\n    ion-icon {\n      font-size: 24px;\n    }\n  }\n\n  .action-bar {\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  .step-description {\n    font-size: 18px;\n    color: var(--ion-color-medium);\n  }\n\n  .select-step-block {\n    margin-top: 50px;\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n\n    .reuse-image {\n      ion-button {\n        width: 500px;\n        height: 300px;\n        margin: 0;\n      }\n    }\n\n    .reuse-image-separator {\n      font-weight: bolder;\n      font-size: 18px;\n    }\n\n    .selection-container {\n      width: 500px;\n      text-align: center;\n\n      .dropzone {\n        width: 500px;\n        height: 300px;\n        padding: 50px 20px 20px;\n        text-align: center;\n        border: dashed 1px var(--ion-color-medium);\n        position: relative;\n        cursor: pointer;\n\n        i {\n          font-size: 50px;\n        }\n\n        input {\n          opacity: 0;\n          position: absolute;\n          z-index: 2;\n          width: 100%;\n          height: 100%;\n          top: 0;\n          left: 0;\n          cursor: pointer;\n        }\n\n        &.fileover {\n          background-color: var(--ion-color-light-shade);\n        }\n      }\n    }\n\n  }\n\n  .crop-container {\n    align-items: center;\n    display: flex;\n    justify-content: space-around;\n\n    .crop-container-actions {\n      display: flex;\n      flex-direction: column;\n    }\n\n    image-cropper {\n      --cropper-outline-color: rgba(0, 0, 0, 0.5);\n      max-width: 800px;\n      max-height: 600px;\n      overflow: hidden;\n    }\n  }\n\n  .flag-container {\n    max-width: 1000px;\n\n    .flag-image-container {\n      max-width: 800px;\n      margin: auto;\n      border: 1px solid var(--ion-color-light-shade);\n\n      img {\n        display: block;\n        -webkit-user-select: none;\n        -khtml-user-select: none;\n        -moz-user-select: none;\n        -o-user-select: none;\n        user-select: none;\n      }\n\n      .flag {\n        position: absolute;\n        z-index: 1;\n        bottom: 50%;\n        left: 50%;\n        font-size: 30px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
